/*
 * An article ran a 1320px image over a 720px text column, leaving 600px of
 * empty paper down the right of the whole page. The headings that would fill
 * it are already in the piece, so the contents list is built from them rather
 * than authored twice and left to drift.
 *
 * Progressive enhancement: without JavaScript the article reads exactly as it
 * did, one column, nothing missing.
 */
(function () {
  // Step 6: pages get the same contents list when they are long enough for
  // one. Six headings and twelve hundred words is the FAQ; a five-hundred
  // word page with six headings is not a page you need a map for.
  var body = document.querySelector('.blog-post-content');
  var page = !body && document.querySelector('.page-content > rte-formatter > .kl-body');
  if (!body && page) {
    var words = page.textContent.trim().split(/\s+/).length;
    if (page.querySelectorAll('h2').length >= 6 && words >= 1200) body = page;
  }
  if (!body) return;

  var headings = Array.prototype.filter.call(
    body.querySelectorAll('h2'),
    function (h) { return h.textContent.trim().length; }
  );

  // Two headings is a list of two, which is not worth a rail.
  if (headings.length < 3) return;

  var slug = function (text, i) {
    var s = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return s ? s.slice(0, 48) : 'section-' + (i + 1);
  };

  var nav = document.createElement('nav');
  nav.className = 'kl-contents';
  nav.setAttribute('aria-labelledby', 'kl-contents-title');

  var title = document.createElement('h2');
  title.className = 'kl-contents__title';
  title.id = 'kl-contents-title';
  title.textContent = 'In this piece';
  nav.appendChild(title);

  var list = document.createElement('ol');
  list.className = 'kl-contents__list';

  headings.forEach(function (h, i) {
    if (!h.id) h.id = slug(h.textContent.trim(), i);
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
  });

  nav.appendChild(list);
  var rail = body.classList.contains('kl-body') && body.parentNode.querySelector(':scope > aside.kl-rail');
  if (body.classList.contains('kl-body')) {
    if (!rail) {
      rail = document.createElement('aside');
      rail.className = 'kl-rail';
      body.parentNode.appendChild(rail);
    }
    // The page rail's own markup: a <p> title, because an h2 here picks up
    // the body's heading rule and size, and a list without the article list
    // class, whose own counter doubled the rail's counter ("1 1Ordering").
    nav.className = 'kl-rail__toc';
    nav.setAttribute('aria-label', 'On this page');
    nav.removeAttribute('aria-labelledby');
    var pageTitle = document.createElement('p');
    pageTitle.className = 'kl-rail__toc-title';
    pageTitle.textContent = 'On this page';
    nav.replaceChild(pageTitle, title);
    list.className = '';
    rail.insertBefore(nav, rail.firstChild);
  } else {
    body.parentNode.insertBefore(nav, body);
  }
  document.documentElement.setAttribute('data-kl-article', 'contents');

  // Mark the section being read. Without this the rail is a list of links that
  // never tells you where you are.

  var links = {};
  Array.prototype.forEach.call(list.querySelectorAll('a'), function (a) {
    links[a.getAttribute('href').slice(1)] = a;
  });

  /*
   * The current section is the last heading that has passed the reading line.
   * This is computed directly from positions rather than from an
   * IntersectionObserver band: the band version compared a heading's viewport
   * top against the observer's own reduced root height, which are two
   * different coordinate systems, so a heading whose band entry and exit both
   * fell outside that comparison never registered. The last section of every
   * piece was one such heading.
   */
  var READING_LINE = 0.32; // of the viewport, measured from the top

  var current = null;
  var mark = function () {
    var line = window.innerHeight * READING_LINE;
    var found = null;

    headings.forEach(function (h) {
      if (h.getBoundingClientRect().top <= line) found = h.id;
    });

    // Past the end of the piece the last heading stays lit rather than going
    // out, which is what a reader scrolled to the bottom expects to see.
    if (!found && headings.length) {
      var first = headings[0].getBoundingClientRect();
      if (first.top < 0) found = headings[headings.length - 1].id;
    }

    if (found === current) return;
    current = found;

    Object.keys(links).forEach(function (id) {
      if (id === current) links[id].setAttribute('aria-current', 'true');
      else links[id].removeAttribute('aria-current');
    });
  };

  var queued = false;
  var onScroll = function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; mark(); });
  };

  // Above 990px the page scrolls inside .page-wrapper, not the window.
  var scroller = document.querySelector('.page-wrapper');
  window.addEventListener('scroll', onScroll, { passive: true });
  if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  mark();
})();
